enum Taxonomy {
  ContentTag = 'content_tag',
  ArticleType = 'article-type',
  Situation = 'situation',
}

export default Taxonomy;
